module.exports = __webpack_public_path__ + "img/sld_scb_1_t1_b1_dark.385f5e87.svg";